import { useSelector } from 'react-redux';

import { ReviewsFixedFooterLayout, ReviewsLayout } from '../../components/ReviewsLayout';
import { RatingsFilterContainer } from '../RatingsFilter';
import { MoreReviewsButtonContainer } from '../MoreReviewsButton';
import { NewReviewButtonContainer } from '../NewReviewButton';
import { RatingsTagsContainer } from '../RatingsTags';
import { ReviewsSortContainer } from '../ReviewsSortContainer';
import { TabsHeaderContainer } from '../TabsHeader/TabsHeader';
import { TabsContainer } from '../Tabs';
import { ItemsListContainer } from '../ItemsList';
import { ModerationLink } from '../../components/ModerationLink';
import { NewQuestionButtonContainer } from '../NewQuestionButton';
import { getIsQuestionTab } from '../../selectors/tabs';
import { MoreQuestionsButtonContainer } from '../MoreQuestionsButton';
import { getReviewsConfig } from '../../utils/getReviewsConfig/getReviewsConfig';

export function ReviewsContainer() {
  const isQuestionTab = useSelector(getIsQuestionTab);

  const reviewsConfig = getReviewsConfig();

  const fixedFooter = reviewsConfig.SHOW_REVIEW_CONTROLS ? (
    <ReviewsFixedFooterLayout
      review={<NewReviewButtonContainer />}
      moderation={<ModerationLink />}
      question={<NewQuestionButtonContainer fill="fill_secondary" />}
    />
  ) : null;

  return (
    <ReviewsLayout
      title={<TabsHeaderContainer />}
      tabs={<TabsContainer />}
      itemsList={<ItemsListContainer />}
      itemsSort={<ReviewsSortContainer />}
      moreReviewsButton={isQuestionTab ? <MoreQuestionsButtonContainer /> : <MoreReviewsButtonContainer />}
      fixedFooter={fixedFooter}
      ratingsFilter={<RatingsFilterContainer />}
      tags={<RatingsTagsContainer />}
    />
  );
}
